// Cube's REST API delivers numeric measures as strings ("5314.98", "0"), and
// nothing on the KPI compareDateRange path converts them (generalPostProcess
// only runs on the non-compare fallback). Every row builder doing arithmetic
// or comparisons on raw row values must coerce through this first — string
// `+` concatenates, and the string "0" is truthy and `!== 0`.

/** Coerces a raw cube cell to a finite number; anything unparseable → 0. */
export function toFiniteNumber(value: unknown): number {
  const n = typeof value === 'number' ? value : parseFloat(value as string);
  return Number.isFinite(n) ? n : 0;
}
